// Global SiteList for components that use the related icons.
// Useful to free up space on pages which already have a lot of data

export default {
  ChildrensHospitalofPhiladelphia: 'Children’s Hospital of Philadelphia',
  UniversityofNorthCarolina: 'University of North Carolina at Chapel Hill',
  UniversityofMarylandBaltimore: 'University of Maryland School of Medicine -  Baltimore',
  WayneStateUniversity: 'Wayne State University/ Detroit Medical Center',
  NúcleodeDoençasInfecciosas: 'Núcleo de Doenças Infecciosas, Vitória, Brazil ',
  UniversityofRochesterRPRC: 'University of Rochester - Respiratory Pathogen Research Center (RPRC)',
  JohnsHopkinsUniversity: 'Johns Hopkins University',
  OhioStateUniversity: 'Ohio State University Clinical Research Center ',
  BostonUniversity: 'Boston University School of Public Health',
  UniversityofAlabama: 'University of Alabama at Birmingham',
  NewYorkInfluenzaCenter: 'New York Influenza Center of Excellence (NYICE) at the University of Rochester ',
  EmoryUniversity: 'Emory University-UGA CEIRS  ',
  StJude: "St. Jude Children's Research Hospital (CEIRS)",
  VanderbiltUniversity: 'Vanderbilt University Medical Center',
  DukeUniversity: 'Duke University',
  BaylorCollege: 'Baylor College of Medicine',
  PerinatalHIVResearchUnit: 'Perinatal HIV Research Unit (PHRU)',
  UniversityofCapeTown: 'University of Cape Town',
  AmericaninhasVaccineCenter: 'Americaninhas Vaccine Center',
  UniversityofMaryland: 'University of Maryland',
  BostonMedicalCenter: 'Boston Medical Center',
  UniversityofRochester: 'University of Rochester',
  NorthwesternMemorialHospital: 'Northwestern Memorial Hospital Laboratory',
  OrlandoClinicalResearchCenter: 'Orlando Clinical Research Center',
  EmoryVaccineCenter: 'Emory Vaccine Center - The Hope Clinic'
}
